<template>
  <div class="content">
    <h4 class="form-title flex-row-align-center">
      <i class="material-icons mar-right-10">color_lens</i>Theme
    </h4>
    <div class="form-row mar-top-20">
      <div class="flex-col flex-expand">
        <label class="mar-bottom-5">Choose Theme</label>
        <DropDown
          :options="themes"
          v-model="selectedTheme"
          :placeholder="'Choose Theme'"
          class="mw-300"
        />
      </div>
      <div class="flex-expand"></div>
    </div>
  </div>
</template>

<script>
import notify from "@/lib/notifications";

export default {
  data() {
    return {
      selectedTheme: {
        id: window.getTheme(),
        name: window.getTheme() === "theme-light" ? "Light" : "Dark",
      },
      themes: [
        {
          id: "theme-light",
          name: "Light",
        },
        {
          id: "theme-dark",
          name: "Dark",
        },
      ],
    };
  },
  watch: {
    selectedTheme(value) {
      window.setTheme(this.selectedTheme.id);
      if (value.id === "theme-dark") {
        notify.info("Welcome to the dark side!");
      }
    },
  },
  mounted() {},
};
</script>

<style lang="scss" scoped>
.content {
  display: flex;
  flex-direction: column;
  padding: 20px 20px;

  .form-title {
    font-weight: bold;
  }
  .form-row {
    display: flex;
    flex-direction: row;
    justify-content: center;

    @include respond-below(md) {
      flex-direction: column;
    }
  }

  .mw-300 {
    max-width: 300px;
  }
}
</style>
